import { Outlet } from 'react-router';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

import { FixtureTabLayout } from 'layouts/FixtureLayout/FixtureTabLayout';

const FootballFixtureLayout = () => {
  const { currentUser } = useCurrentUserContext();
  if (!currentUser?.anyUserSportProfile?.proUnlocked) {
    return <Outlet />;
  }
  return (
    <FixtureTabLayout
      so5FixtureSlug="ongoing"
      eventType={So5FixtureEvent.CLASSIC}
    >
      <Outlet />
    </FixtureTabLayout>
  );
};
export default FootballFixtureLayout;
